



























import Vue from 'vue'
import Coin from './Coin.vue'
import { salaryExpectationClass } from '../types'

export default Vue.extend({
  name: 'SalaryExpectation',
  props: ['availableSalaryExpectations', 'myBoss', 'connections', 'myApplication'],
  components: {
    Coin,
  },
  data() {
    return {
      theSalaryExpectationClass: salaryExpectationClass,
    }
  },
})
